module.exports = __webpack_public_path__ + "static/assets/f8fdb56abe010a87ef74eeb9db4839eb.svg";